import React, { useState } from 'react';
import Map from './components/Map';
import type { Campsite } from './components/Map'; // adjust path as needed

import POIForm from './components/POIForm';
import './styles/main.css';
import 'leaflet/dist/leaflet.css';


type POI = {
    name: string;
    description: string;
    latitude: number;
    longitude: number;
};

function App() {
    const [selectedCoords, setSelectedCoords] = useState<{ latitude: number; longitude: number } | null>(null);
    const [pois, setPOIs] = useState<POI[]>([]);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [campsiteMarkers, setCampsiteMarkers] = useState<any[]>([]);
    const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number } | null>(null);
    const [selectedSite, setSelectedSite] = useState<Campsite | null>(null);
    const [markers, setMarkers] = useState<Campsite[]>([]);


    const handleAddPOI = (poi: POI) => {
        if (editingIndex !== null) {
            // Update existing POI
            const updatedPOIs = [...pois];
            updatedPOIs[editingIndex] = poi;
            setPOIs(updatedPOIs);
            setEditingIndex(null);
        } else {
            // Add new POI
            setPOIs([...pois, poi]);
        }
    };

    const handleEditPOI = (index: number) => {
        setEditingIndex(index);
        setSelectedCoords({ latitude: pois[index].latitude, longitude: pois[index].longitude });
    };

    const fetchNearbySites = async (lat: number, lng: number) => {
  const url = 'https://corsproxy.io/?https://www.searchforsites.co.uk/pdo/getData.php';

  const payload = new URLSearchParams({
    radius: '20',
    limit: '20',
    type: 'default',
    zoom: '13',
    view: 'map',
    lat: lat.toString(),
    lng: lng.toString()
  });

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: payload.toString()
    });

    const data = await response.json();
    const resultsObj = data.results || {};
    const resultsArr = Object.values(resultsObj);
    setCampsiteMarkers(resultsArr); // ✅ update marker state
  } catch (error) {
    console.error('Error fetching nearby sites:', error);
  }
};



    return (
        <div>
            <div className="app">
                <Map onMapClick={setSelectedCoords}
                    pois={pois}
                    onMarkerClick={handleEditPOI}
                    markers={campsiteMarkers}
                    mapCenter={mapCenter}
                    setMapCenter={setMapCenter}
                    sites={campsiteMarkers}
                    selectedSite={selectedSite}
                    onSiteSelect={setSelectedSite} 
                    fetchNearbySites={fetchNearbySites} />
            </div>

        </div>
    );
}

export default App;